import styled from 'styled-components';

export const SliderWrapper = styled.div`
  height: 100%;
  border: 1px solid
    ${({ theme: { color, palette } }) => (palette.mode === 'dark' ? color.backgroundDark : color.borderGray)};
  background-color: ${({ theme: { color, palette } }) =>
    palette.mode === 'dark' ? color.backgroundPaperDark : color.white};
  display: flex;
  flex-direction: column;
  width: ${({
    theme: {
      sizing: { receiptWidth },
      breakpoints,
    },
  }) => (breakpoints.down('tabletLandscape') ? `auto` : receiptWidth)};
`;

export const StyledSubheaderWrapper = styled.div`
  display: flex;
  align-items: center;
`;

export const StyledProductImage = styled.img`
  width: 80%;
  margin: ${({ theme: { spacing } }) => spacing(3, 0, 3, 0)};
  border-radius: ${({ theme: { spacing } }) => spacing(3)};
  overflow: hidden;
`;

export const StyledProductSmallImage = styled.img<{ isSelected?: boolean }>`
  width: ${({ theme: { spacing } }) => spacing(20)};
  border-radius: ${({ theme: { spacing } }) => spacing(3)};
  border: 2px solid ${({ theme: { color }, isSelected }) => isSelected && color.red};
  cursor: pointer;
  overflow: hidden;
`;

export const StyledDetailsProperty = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: ${({ theme: { spacing } }) => spacing(3)};

  &:last-child {
    margin-bottom: 0px;
  }
`;

export const StyledAboutInfo = styled.div`
  display: flex;
  flex-direction: column;
  padding: ${({ theme: { spacing } }) => spacing(5, 5, 0, 5)};
  align-items: flex-start;

  & > * {
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
  }
`;

export const StyledColor = styled.div<{ color: string }>`
  background-color: ${({ color }) => color || 'transparent'};
  border: 1px solid ${({ theme: { color: themeColor } }) => themeColor.borderGray};
  width: ${({ theme: { spacing } }) => spacing(5)};
  height: ${({ theme: { spacing } }) => spacing(5)};
  border-radius: 50%;
`;
